<template>
  <div class="menu">
    <nav class="text-center">
      <!-- <router-link to="/home">首页</router-link>
        <router-link to="/about">关于大赛</router-link>
        <router-link to="/dynamic">竞赛动态</router-link>
        <a href="#">社会反响</a>
        <router-link to="/works">佳作展示</router-link>
        <a href="#">证书查询</a>
        <a href="#">报名中心</a> -->
      <ul class="menu-list m-flex m-row-center">
        <li
          v-for="item in nav_list"
          :key="item.text"
          @click="navChang(item)"
          class="m-flex-1"
          :class="nav_active == item.text ? 'active' : ''"
        >
          <router-link v-if="item.path" :to="{ name: item.name }">{{
            item.text
          }}</router-link>
          <a v-else href="#">{{ item.text }}</a>
          <div class="submenu">
            <ul>
              <li v-for="children in item.children" :key="children.text">
                <router-link
                  v-if="children.path"
                  :to="{ name: children.name, params: children.params }"
                  >{{ children.text }}</router-link
                >
                <a v-else href="#">{{ children.text }}</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
    <!--  <el-menu
      :default-active="activeIndex"
      class="el-menu-demo m-flex m-row-center text-center"
      mode="horizontal"
      text-color="#fff"
      active-text-color="#fff"
      router
      @select="handleSelect"
    >
      <template v-for="item in nav_list">
        <el-menu-item
          :index="item.path || ''"
          v-if="!item.children"
          :key="item.text"
          >{{ item.text }}</el-menu-item
        >
        <el-submenu :index="item.path || ''" v-else :key="item.text + 1">
          <template slot="title">{{ item.text }}</template>
          <el-menu-item
            v-for="submenu in item.children"
            :key="submenu.text"
            :index="submenu.path || ''"
            >{{ submenu.text }}</el-menu-item
          >
        </el-submenu>
      </template>
    </el-menu> -->
  </div>
</template>

  <script>
export default {
  name: "NavMenu",
  props: {
    msg: String,
  },
  data() {
    return {
      nav_list: [
        {
          path: "/home",
          name: "home",
          text: "首页",
        },
        {
          text: "关于我们",
          children: [
            {
              path: "/introduce",
              name: "introduce",
              text: "大赛介绍",
            },
            {
              path: "/rule",
              name: "rule",
              text: "大赛章程",
            },
            {
              path: "/unit",
              name: "unit",
              text: "竞赛单元",
            },
            {
              path: "/program",
              name: "program",
              text: "电视节目",
            },
            {
              path: "/consultant",
              name: "consultant",
              text: "专家顾问",
            },
          ],
        },
        {
          path: "/dynamic",
          name: "dynamic",
          text: "竞赛动态",
        },
        {
          path: "",
          text: "社会反响",
          children: [
            {
              path: "/MediaAttitude",
              name: "MediaAttitude",
              text: "媒体热议",
            },
            {
              path: "/carryOut",
              name: "carryOut",
              text: "各地开展",
            },
          ],
        },
        {
          path: "/works",
          name: "works",
          text: "佳作展示",
        },
        {
          path: "/query",
          name: "query",
          text: "成绩查询",
        },
        /*{
          path: "/StudyFinland",
          name: "StudyFinland",
          text: "报名中心",
        },*/
      ],
      nav_active: "",
    };
  },
  created() {
    this.getNavList();
  },
  methods: {
    // 获取路由
    getNavList() {
      let path = this.$route.path;
      this.nav_list.forEach((value) => {
        if (value.path) {
          if (value.path == path) return (this.nav_active = value.text);
        } else {
          if (!value.children) return;
          value.children.forEach((children) => {
            if (children.path == path) return (this.nav_active = value.text);
          });
        }
      });
    },
    navChang(item) {
      const that = this;
      this.nav_active = item.text;
      setTimeout(() => {
        that.getNavList();
        document.documentElement.scrollTop = 0;
      }, 50);
    },
    // 点击导航
    handleSelect(key, keyPath) {
      console.log(key);
    },
  },
};
</script>

<style lang="scss">
// 背景色
$bgstart: #ef4000;
$bgend: #ba0e02;
// 选中颜色
$active1: #C01302;
$active2: #E83900;

// 导航高度
$height: 50px;
nav {
  background: linear-gradient(180deg, $bgstart, $bgend);
  a {
    display: inline-block;
    width: 100%;
    height: $height;
    line-height: $height;
    font-size: 20px;
    color: #ffffff;
    font-weight: 400;
    background:linear-gradient(180deg,rgba(255,255,255,.4),rgba(255,255,255,0)) no-repeat right/1px,
    linear-gradient(180deg,rgba(255,255,255,.4),rgba(255,255,255,0)) no-repeat left/1px;
    &:hover {
      background:linear-gradient(180deg,$active1,$active2);
    }
  }
  & .menu-list {
    & ul {
      background: linear-gradient(180deg, $bgstart, $bgend);
    }
    & > .active {
      background:linear-gradient(180deg,$active1,$active2);
    }
    & > li {
      position: relative;
      &:hover {
        background:linear-gradient(180deg,$active1,$active2);
        .submenu {
          max-height: 1000px;
          & > ul {
            transform: translate(0, 0);
          }
        }
      }
      & .submenu {
        position: absolute;
        width: 100%;
        max-height: 0;
        overflow: hidden;
        transition: all 0.2s linear;
        & > ul {
          transition: transform 0.2s linear;
          transform: translate(0, -100%);
        }
      }
    }
  }
}
</style>
